import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { SearchApi } from '@backstage/plugin-search-react';
import { SearchQuery, SearchResultSet } from '@backstage/plugin-search-common';
import qs from 'qs';
import createDebugger from 'debug';

const debug = createDebugger('search:api_client');

export class SearchClient implements SearchApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async query(query: SearchQuery): Promise<SearchResultSet> {
    let tabType;
    let hasFilters = true;
    if (!query.types || query.types.length === 0) {
      tabType = 'handbook';
    } else {
      tabType = query.types[0];
    }
    if (!query.filters || Object.keys(query.filters).length === 0) {
      hasFilters = false;
    }
    let queryString = qs.stringify(query);
    if (query.types && query.types[0] === 'all') {
      query.types = [];
      queryString = qs.stringify(query);
    }
    let responseData;
    do {
      let modifiedQueryString = queryString;
      if (responseData?.nextPageCursor) {
        modifiedQueryString = qs.stringify({
          ...query,
          pageCursor: responseData.nextPageCursor,
        });
      }
      const url = `${await this.discoveryApi.getBaseUrl(
        'search',
      )}/query?${modifiedQueryString}`;
      const response = await this.fetchApi.fetch(url);

      if (!response.ok) {
        throw await ResponseError.fromResponse(response as any);
      }

      responseData = await response.json();
      debug('response from backend', responseData);
      if (tabType === 'techdocs' && hasFilters) {
        return responseData;
      }
      responseData.results = responseData.results.filter(
        (result: any) => !result.document.globalSearchExclude,
      );
    } while (
      responseData?.results.length === 0 &&
      responseData?.nextPageCursor
    );

    debug('return responseData', responseData);

    return responseData;
  }
}
